var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-list',[_c('ion-item',{staticClass:"cursor-pointer",attrs:{"lines":"inset"},on:{"click":function($event){return _vm.viewDashboard()}}},[_vm._v(" View Patient Overview ")]),_c('ion-item',{staticClass:"cursor-pointer",attrs:{"lines":"none"},on:{"click":function($event){return _vm.viewTasks()}}},[_vm._v(" View Patient Tasks ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }